import { Link } from 'react-router-dom';
import iconInvestment from 'assets/images/iconInvestment.svg';

function Investment() {
  return (
    <div className="w-full bg-[#5FB89E]/[.12]">
      <div className="container px-4 md:px-0 flex flex-wrap justify-between items-center mx-auto py-[50px] md:py-[100px] ">
        <div className="grid grid-cols-1 md:grid-cols-5 md:gap-4 w-full">
          <div
            className="col-span-2"
            data-aos="fade-right"
          >
            <img
              alt="transaction"
              src={iconInvestment}
              className="max-w-full h-auto"
            />
          </div>
          <div
            className="col-span-3 md:pl-20 flex flex-col justify-center mt-10 md:mt-0 max-w-[600px] text-center md:text-left"
            data-aos="fade-left"
          >
            <div className="font-bold md:text-lg mx-auto md:max-w-max md:ml-0">
              Đầu tư phân đoạn với số vốn linh hoạt
            </div>
            <div className="mt-5">
              <Link
                to="/"
                className="bg-mka-primary py-2 px-4 rounded-full text-white uppercase font-bold"
              >
                Xem thêm
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Investment;
